import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { useTranslation, Trans } from "react-i18next"
import toast from "react-hot-toast"

export const ModalEliminarQA = ({ show, entry, setEntries }) => {
  // <- nombre

  const query = useQuery()

  const handleDelete = async () => {
    const { url, opt } = await api.qa.delete({
      // <- api endpoint
      token: getCookie("jwt"),
      qa_id: entry.id, // <- args de la api (lado izq)
    })

    // ejecuto
    query.url.current = url
    query.opt.current = opt

    query.run({
      onOk: () => {
        setEntries((currents) => ({
          ...currents,
          entries: currents.entries.filter((c) => c.id !== entry.id),
        }))
        toast.success(
          <span>
            <Trans
              i18nKey={`admin.qa.has_been_deleted`}
              values={{ name: entry.title + " " }}
              components={[<i />]}
            />
          </span>
        )
        show[1](false)
      },
    })
  }

  const modalFooter = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => show[1](false)}>
          {t("ui.btns.cancel")}
        </button>

        <button
          type="button"
          className="btn btn-danger"
          disabled={query.isPending}
          onClick={() => handleDelete()}>
          {query.isPending ? `${t("ui.btns.deleting")}...` : t("ui.btns.yes")}
        </button>
      </>
    )
  }

  const { t } = useTranslation()

  return (
    <>
      <Modal
        id="confirmar-accion"
        show={show}
        className="darkie"
        header={<center>{t(`ui.msgs.confirm_action`)}</center>}
        body={msg(
          <Trans
            i18nKey="modals.modal_delete_qa.are_you_sure"
            values={{ title: entry.title }}
            components={{ b: <b /> }}
          />
        )}
        footer={modalFooter()}
      />

      {/* en caso de erro, muestro una modal */}
      {query.res && query.err && <ModalError show={show} res={query.res} />}
    </>
  )
}
